module.exports = __webpack_public_path__ + "static/media/Sec-2_2677_AboutUs_CN.ffcab320.webp";